// Hide Header on scroll down - Vanilla JavaScript (Performance Optimized)
let didScroll = false;
let lastScrollTop = 0;
const delta = 5;
let navbarHeight = 0;

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('x-header.header');
    if (header) {
        navbarHeight = header.offsetHeight;
        
        // Add smooth transition for header hide/show animation
        header.style.transition = 'top 0.3s ease';
        
        // Recalculate on resize
        window.addEventListener('resize', function() {
            navbarHeight = header.offsetHeight;
        }, { passive: true });
    }
});

// Optimized scroll event with passive listener for better performance
window.addEventListener('scroll', function() {
    didScroll = true;
}, { passive: true });

// Throttled scroll handler - runs every 250ms for smooth performance
setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    const header = document.querySelector('x-header.header');
    
    if (!header) return;
    
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) {
        return;
    }

    // If they scrolled down and are past the navbar, hide header
    if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down - Hide header
        header.classList.add('nav-up');
    } else {
        // Scroll Up - Show header
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        
        if (st + windowHeight < documentHeight) {
            header.classList.remove('nav-up');
        }
    }

    lastScrollTop = st;
}
